export type GeoCoordinates = [number, number];

export interface AddressDetails {
  formattedAddress: string;
  streetAddress: string;
  locality: string;
  subLocality: string;
  region: string;
  country: string;
  postalCode: string;
  area: string;
  geo: GeoCoordinates;
}

export const DEFAULT_ADDRESS_DETAILS: AddressDetails = {
  formattedAddress: '',
  streetAddress: '',
  locality: '',
  subLocality: '',
  region: '',
  country: '',
  postalCode: '',
  area: '',
  geo: [0, 0]
};
